import { isUndefined } from 'lodash-es';
import { PropsWithChildren } from 'react';

import { getIndicatorsFromAnnotations } from '../components/annotations/utils/get-indicators-from-annotations.js';
import { XYChartAnnotationsDataContext } from '../context/XYChartAnnotationsData.context.js';
import { XYChartAnnotationsHiddenTracksContext } from '../context/XYChartAnnotationsHiddenTracks.context.js';
import { XYChartAnnotationsIndicatorsContext } from '../context/XYChartAnnotationsIndicators.context.js';
import { useXYChartAnnotationsConfig } from '../hooks/useXYChartAnnotationsConfig.js';

export const XYChartAnnotationsDataProvider = ({
  children,
}: PropsWithChildren) => {
  const annotationsConfig = useXYChartAnnotationsConfig();

  if (isUndefined(annotationsConfig) || isUndefined(annotationsConfig?.data)) {
    return children;
  }

  const { data, tracksConfig, markersConfig } = annotationsConfig;
  const { indicators, annotationsByTrack, hiddenTracks } = getIndicatorsFromAnnotations(
    data,
    tracksConfig,
    markersConfig,
  );

  return (
    <XYChartAnnotationsDataContext.Provider value={annotationsByTrack}>
      <XYChartAnnotationsHiddenTracksContext.Provider
        value={Array.from(hiddenTracks)}
      >
        <XYChartAnnotationsIndicatorsContext.Provider value={indicators}>
          {children}
        </XYChartAnnotationsIndicatorsContext.Provider>
      </XYChartAnnotationsHiddenTracksContext.Provider>
    </XYChartAnnotationsDataContext.Provider>
  );
};
